import React, { useState, useEffect } from 'react';

import validate from '@vlabs/shared/validators';
import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { hasAnyError } from '../helpers';
import { useFilterCount } from '../hooks/useFilterCount';

export const EventIdsInputsPopover = ({ onCountChange = undefined }) => {
  const { register, formState: { errors }, setValue } = useFormContext();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(hasAnyError(errors, ['event_ids', 'external_ids']));
  }, [errors, errors.event_ids, errors.external_ids]);

  const [eventIds, externalIds] = useWatch({ name: ['event_ids', 'external_ids'] });
  const filterCount = [eventIds, externalIds]
    .filter((value) => typeof value === 'string' && value.trim().length > 0)
    .length > 0 ? 1 : 0;
  useFilterCount('events', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasError={hasError}
      hasFilterValue={Boolean(filterCount)}
      testId="eventIdsFilter"
      triggerValue={t('id событий')}
    >
      <Control.Input
        id="event_ids"
        label={t('id событий')}
        {...register('event_ids', { validate: validate.multipleUuid() })}
        errors={errors}
        isClearable
        onClear={() => setValue('event_ids', '')}
      />
      <Divider small />
      <Control.Input
        id="external_ids"
        label={t('внешние id событий')}
        {...register('external_ids', {
          validate: validate.multipleExternalId(),
        })}
        errors={errors}
        isClearable
        onClear={() => setValue('external_ids', '')}
      />
    </CustomFilterPopover>
  );
};
